import React from 'react'
import styled from 'styled-components'
import DatePicker, { registerLocale } from "react-datepicker";
import esLocale from "date-fns/locale/es";

import "react-datepicker/dist/react-datepicker.css";

const ContainerInput = styled.div<{ background: string, className: string }>`
    background: ${p => p.background};
    display: flex;
    justity-content: center;
    flex-direction: row;
    align-items: center;
    padding: 6px;
    border-radius: 5px;
    margin: 6px 4px;
    height: 50px;
    position: relative;
    width: inherit;
    cursor: pointer;
    
    > div {
        min-width: 15px;
        margin-left: 5px;
        margin-right: 5px;
    }
    
    > div svg{
        color: ${p => p.theme.palette.primary.main};
    }
    
    > input{
        width: 100%;
        outline: none;
        border: none;
        background: ${p => p.background};
        padding:2px;
    }

    > input[type="date"]::-webkit-inner-spin-button,
    > input[type="date"]::-webkit-calendar-picker-indicator {
        display: none;
        -webkit-appearance: none;
    }

    ${p => p.className}
    `

    const CustomButtom = styled.div`
    border: 0;
    color: #838383;
    font-weight: initial;
    font-size: 13px;
`
interface IOwnProps{
    textHolder: string
    background?: string
    className?: string
    icon?: React.ReactElement
}

const CalendarTC: React.FunctionComponent<IOwnProps> = ({
    icon,
    textHolder,
    background = '#F2F2F2',
    className = ''
}) => {
    const [startDate, setStartDate] = React.useState(new Date());
    const [firstClick, setFirstClick] = React.useState(false);
    registerLocale("spanish", esLocale);

    const ExampleCustomInput = React.forwardRef(({ value, onClick } : any, ref: any) => (
        <CustomButtom onClick={onClick} ref={ref}>
            {!firstClick ? textHolder : value}
        </CustomButtom>
    ));

  return (
    <ContainerInput background={background} className={className}>
        {!!icon && <div>{icon}</div>}
        <DatePicker
            selected={startDate}
            onChange={(date : any) => {
                setStartDate(date)
                setFirstClick(true)
            }}
            locale="spanish"
            minDate={new Date()}
            customInput={<ExampleCustomInput />}
            showDisabledMonthNavigation
        />
    </ContainerInput>
  )
}

export default CalendarTC